module.exports = __webpack_public_path__ + "media/images/locations/muenchenstein-map-0255b440ece6c5a04ada2d999b532e51.jpg";